import React, { useState } from 'react';
import IosShareIcon from '@mui/icons-material/IosShare';
import IosAdd from "../../assets/iosAdd.png";
import colors from '../../theme';


const Popup = () => {
  const [showPopup, setShowPopup] = useState(true);

  const closePopup = () => {
    setShowPopup(false);
  };

  const popupContainerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999
  };

  const popupContentStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '90%',
    maxWidth: '400px',
    position: 'relative',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    textAlign: 'center'
  };

  // const closeButtonStyle = {
  //   position: 'absolute',
  //   top: '10px',
  //   right: '10px',
  //   border: 'none',
  //   background: 'transparent',
  //   fontSize: '16px',
  //   cursor: 'pointer'
  // };

  const okButtonStyle = {
    display: 'block',
    margin: '20px auto 0',
    padding: '10px 20px',
    backgroundColor: colors.secondary,
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer'
  };

  const olStyle = {
    textAlign: 'left',
    marginLeft: '20px'
  };

  return (
    <>
      {showPopup && (
        <div style={popupContainerStyle}>
          <div style={popupContentStyle}>
            <h2>Install ReadySteadyPlug App</h2>
            <p>For better user experience, install this as an app on your iOS device, using the following steps:</p>
            <ol style={olStyle}>
              <li>Tap the Share button <IosShareIcon style={{
                marginTop: "-5px"
              }}/> at the bottom of the Safari browser.</li>
              <li>Scroll down and tap "Add to Home Screen
                <img
                src={IosAdd}
                alt=''
                style={{ width: 19, margin: "0 4px 0 8px" }}
                />
                ".
              </li>
              <li>Tap "Add" in the upper right corner.</li>
              <li>Enjoy the app from your home screen!</li>
            </ol>
            <button style={okButtonStyle} onClick={closePopup}>OK</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;